import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { ShopCategoriesService } from '../customer-management/services/shop-categories.service';
import { OfflineShopAdminRoutingModule } from './offline-shop-admin-routing.module'
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MaterialModule } from '../material.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { ProductsComponent } from './components/products.component';
import { TableProductsComponent } from './components/table-products/table-products.component';
import { ProductsResolver } from './services/resolvers/products-resolver.service';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { PortalModule } from '@angular/cdk/portal';
import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { OfflineProductComponent } from './components/product-details/offline-product.component';
import { CoreModule } from '../../core/core.module';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CategoriesService } from 'src/app/core/services/categories.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ProductFilterComponent } from './components/product-filter/product-filter.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        OfflineShopAdminRoutingModule,
        MatFormFieldModule,
        MatSelectModule,
        MaterialModule,
        MatTabsModule,
        MatInputModule,
        CdkScrollableModule,
        ScrollingModule,
        PortalModule,
        MatSelectInfiniteScrollModule,
        CoreModule,
        MatDialogModule,
        NgxMatSelectSearchModule,
        SharedModule
    ],
    declarations: [
        ProductsComponent,
        TableProductsComponent,
        OfflineProductComponent,
        ProductFilterComponent,
    ],
    exports: [
        OfflineProductComponent
    ],
    providers: [
        CategoriesService,
        ProductsResolver,
        {
            provide: MatDialogRef,
            useValue: {}
        },
        ShopCategoriesService,
    ]
})
export class OfflineShopAdminModule { }
